import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import AnonymousRoute from '../../components/accessControl/AnonymousRoute';
import ProtectedRoute from '../../components/accessControl/ProtectedRoute';
import SignIn from '../Auth/SignIn';
import Register from '../Auth/Register';
import VerifyEmail from '../Auth/VerifyEmail';
import { getAppVersion, tryLocalSignIn } from '../../store/actions';
import RequestVerificationEmail from '../Auth/RequestVerificationEmail';
import RequestPasswordReset from '../Auth/RequestPasswordReset';
import ResetPassword from '../Auth/ResetPassword';
import { getIsSignedIn } from '../../store/selectors';
import Dashboard from '../../layouts/Dashboard';

class App extends React.Component {
  componentDidMount() {
    this.props.tryLocalSignIn();
    this.props.getAppVersion();
  }

  render() {
    return (
      <Switch>
        <AnonymousRoute path="/signin" component={SignIn} />
        <AnonymousRoute path="/register" component={Register} />
        <AnonymousRoute path="/verify-email/:token" component={VerifyEmail} />
        <AnonymousRoute
          path="/request-verification-email"
          component={RequestVerificationEmail}
        />
        <AnonymousRoute
          path="/request-password-reset"
          component={RequestPasswordReset}
        />
        <AnonymousRoute
          path="/reset-password/:token"
          component={ResetPassword}
        />
        <ProtectedRoute path="/dashboard" component={Dashboard} />

        <Route path="/">
          {this.props.isSignedIn ? (
            <Redirect to="/dashboard" />
          ) : (
            <Redirect to="/signin" />
          )}
        </Route>
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSignedIn: getIsSignedIn(state),
  };
};

export default connect(mapStateToProps, { getAppVersion, tryLocalSignIn })(App);
